export var NOTIFICATIONS_COMPONENTS_I18N_KEY = 'cross-top-bar-components-notifications';